import Vue from 'vue';
import { MutationTree } from 'vuex';
import { GroupModel } from '@/models/Group';
import GroupState from './state';
import { MutationTypes } from './mutation-types';
import { BaseGroupingStrategy } from '@/helper/groupingStrategy';
import { BaseDecideOddsStrategy } from '@/helper/decideOddsStrategy';

const mutations: MutationTree<GroupState> = {
    [MutationTypes.RESET](state: GroupState) {
        state.groups.length = 0;
    },

    [MutationTypes.LOAD](state: GroupState, groups: GroupModel[]) {
        state.groups = groups;
    },

    [MutationTypes.SET_DRAWED](state: GroupState, group: GroupModel) {
        state.drawedGroup = group;
    },

    [MutationTypes.CHANGE_GROUPING_STRATEGY](state: GroupState, groupingStrategy: BaseGroupingStrategy) {
        state.groupingStrategy = groupingStrategy;
    },

    [MutationTypes.CHANGE_ODDS_STRATEGY](state: GroupState, decideOddsStrategy: BaseDecideOddsStrategy) {
        state.decideOddsStrategy = decideOddsStrategy;
    },
};

export default mutations;
